import app from 'flarum/common/app';
import { extend } from 'flarum/common/extend';
import EditUserModal from 'flarum/common/components/EditUserModal';

app.initializers.add('laya-auth-common', () => {
  extend(EditUserModal.prototype, 'fields', function (items) {
    if (items.has('password')) {
      items.add('layaPasswordHelp', m('.Form-group.helpText', app.translator.trans('laya-auth.lib.edit_user.password_help')), 19);
    }
  });
});
